module.exports = __webpack_public_path__ + "static/media/Mentorship-12.69f27f9f.jpg";